import Login from './Login';
import { UserIsNotAuthenticated, siteTitle } from '../';

const LoginRoutes = {
		login: {
				path: '/Login',
				label: 'Login',
				title: `${siteTitle} - Login`,
				component: UserIsNotAuthenticated(Login)
		}
};

export { LoginRoutes, Login };



// WEBPACK FOOTER //
// ./src/app/containers/Login/index.ts